export default __webpack_public_path__ + "components/weather-icon/static/dayrisksnow-1a9b6bfbef284bcfffd12cf2c1d74bc9.svg";